module.exports = __webpack_public_path__ + "static/media/train10.0977a56b.png";